const SubmitButton = () => (
    <div className="col-md-4 mb-3">
        <div className="form-group">
            <button type="submit" className="btn btn-primary" >Submit</button>
        </div>
    </div>
)

export default SubmitButton;